import React from 'react'
import map from 'lodash/map'
import { useBlogCategoryTreeViewContext } from './Context'
import { BlogCategoryTreeNode } from './BlogCategoryTreeNode'

export const BlogCategoryTree = () => {
  const { tree } = useBlogCategoryTreeViewContext()

  return (
    <ul aria-label="Blog categories" className="list-unstyled m-0">
      {map(tree.items, (category) => (
        <BlogCategoryTreeNode key={category._id} category={category} />
      ))}
    </ul>
  )
}
